/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechCamVideoOffIcon16Light } from './TechCamVideoOffIcon16Light';
import { TechCamVideoOffIcon16Regular } from './TechCamVideoOffIcon16Regular';
import { TechCamVideoOffIcon16Solid } from './TechCamVideoOffIcon16Solid';
import { TechCamVideoOffIcon20Light } from './TechCamVideoOffIcon20Light';
import { TechCamVideoOffIcon20Regular } from './TechCamVideoOffIcon20Regular';
import { TechCamVideoOffIcon20Solid } from './TechCamVideoOffIcon20Solid';
import { TechCamVideoOffIcon24Regular } from './TechCamVideoOffIcon24Regular';
import { TechCamVideoOffIcon24Solid } from './TechCamVideoOffIcon24Solid';
import { TechCamVideoOffIcon32Regular } from './TechCamVideoOffIcon32Regular';
import { TechCamVideoOffIcon64Regular } from './TechCamVideoOffIcon64Regular';
var sizes = {
    16: {
        light: TechCamVideoOffIcon16Light,
        regular: TechCamVideoOffIcon16Regular,
        solid: TechCamVideoOffIcon16Solid,
    },
    20: {
        light: TechCamVideoOffIcon20Light,
        regular: TechCamVideoOffIcon20Regular,
        solid: TechCamVideoOffIcon20Solid,
    },
    24: {
        regular: TechCamVideoOffIcon24Regular,
        solid: TechCamVideoOffIcon24Solid,
    },
    32: {
        regular: TechCamVideoOffIcon32Regular,
    },
    64: {
        regular: TechCamVideoOffIcon64Regular,
    },
};
export var TechCamVideoOffIcon = forwardRef('TechCamVideoOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
